import StaffQuickLoginScreen from '@screens/staff/quick-login'

export default function StaffQuickLoginPage() {
  return <StaffQuickLoginScreen />
}
